/**
 * Strips characters problematic for a file system from a project name, for
 * a downloadable file's suggested name — shared by exportProject.ts
 * (.ehdz) and exportCsvProject.ts (the CSV zip), which used to each
 * hand-write the exact same sanitizer. No `Translate` available at either
 * call site (both are plain, synchronous filename builders), so the
 * fallback for an empty/all-problematic name is a fixed English default
 * rather than a translated one.
 */
export function sanitizedProjectFileName(projectName: string): string {
  return projectName.trim().replace(/[\\/:*?"<>|]+/g, "-") || "project";
}
